import { FC } from 'react'

import PageHeading from 'components/atoms/PageHeading'
import MainTable from 'components/organisms/tables/MainTable'
import GroupCourseEnrollTeacherForm from 'components/organisms/forms/GroupCourseEnrollTeacherForm'

import { useTableModel } from 'utils/tableModels/useGroupCourseEnrolledTeachersTableModel'

import { useTranslation } from 'react-i18next'
import { Grid } from '@mui/material'
import { useGET_teachersQuery } from 'redux/api/teachersApi'
import { removeEmpty } from 'utils/helpers'


interface IProps {
  id: number
  viewOnly: boolean
  tabText?: string
  tabKey?: string
}

  
const GroupCourseEnrolledTeachers: FC<IProps> = ({ id, viewOnly }) => {
  const { t } = useTranslation()
  const filters = {
    group_course: id,
  }

  return (
    <>
      <Grid container spacing={4} sx={{ marginTop: '-1rem' }}>
        <Grid item xs={6}>
          <PageHeading title={t('common.enrolled-teachers')} /> 
        </Grid>
        <Grid item xs={6}>
          <GroupCourseEnrollTeacherForm id={id} viewOnly={viewOnly} />
        </Grid>
      </Grid>

      <MainTable
        useTableModel={useTableModel}
        getTableData={useGET_teachersQuery}
        tableRowParams={ {group_course_id: id} }
        filters={filters}
        header={null}
      />
    </>
  )
}
export default GroupCourseEnrolledTeachers